export {
  default, InputHint, InputIcon, InputLabel,
} from './Input';
